export default __webpack_public_path__ + "static/media/carousel_2_1280.03ac37ef.webp";